import { Paper, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import useProfileStore from "../../store/useProfileStore";
import useAuthStore from "../../store/useAuthStore";
import { EditIcon } from "../../shared/svg";
import { useNavigate } from "react-router";

export const Certifications = () => {
  const { profile } = useProfileStore();
  const { cvProcessing } = useAuthStore();
  const certifications = profile?.certifications || [];
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formatYear = (date: string) => {
    const year = new Date(date).getFullYear();
    return year ? year.toString() : "";
  };

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/certificates")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("certifications")}
      </Title>

      {certifications.length > 0 ? (
        certifications.map((item, index) => (
          <div key={index}>
            <Title
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
                maxWidth: "100%",
              }}
              size={24}
              mt={40}
            >
              {item.title}
            </Title>
            <Text
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
                maxWidth: "100%",
              }}
              mt={8}
            >
              {item.issuer}
            </Text>
            {item.issue_date && (
              <Text mt={8} c="#737373">
                {formatYear(item.issue_date)}
              </Text>
            )}
          </div>
        ))
      ) : (
        <Text mt={30} c="#737373">
          {cvProcessing !== "processing"
            ? t("no_certifications")
            : t("no_certifications_cv")}
        </Text>
      )}
    </Paper>
  );
};
